<template>
  <teleport to="#vue-app">
    <transition
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="translate-y-full opacity-0 md:translate-y-0 md:translate-x-full"
      enter-to-class="translate-y-0 opacity-100 md:translate-x-0"
      leave-active-class="transition-all duration-300 ease-in"
      leave-from-class="translate-y-0 opacity-100 md:translate-x-0"
      leave-to-class="translate-y-full opacity-0 md:translate-y-0 md:translate-x-full"
    >
      <div
        v-if="showPopup"
        class="fixed inset-x-0 bottom-0 z-50 w-full rounded bg-gray-800 p-4 shadow-lg md:inset-x-auto md:bottom-auto md:right-4 md:top-32 md:w-96"
      >
        <button
          class="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
          @click="closePopup"
        >
          <XMarkIcon class="size-5" />
        </button>
        <div class="flex items-center space-x-4 pr-8">
          <div class="shrink-0">
            <img
              class="size-20 object-cover"
              :src="productImageToShow"
              :alt="likedProduct?.name"
            />
          </div>
          <div class="min-w-0 flex-1">
            <h3 class="mb-1 text-base font-medium text-white">Añadido a favoritos</h3>
            <h4 class="mb-2 line-clamp-1 text-lg font-semibold text-white">{{ likedProduct?.name }}</h4>
            <a
              :href="linkUrl"
              class="text-sm text-white underline hover:text-gray-300"
            >
              Ver mis productos favoritos
            </a>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { computed, watch, inject, type Ref } from 'vue';
import { XMarkIcon } from '@heroicons/vue/24/solid';
import { useLikedProductPopup } from './use/liked-product-popup';
import useSessionStore from 'stores/user-store';

const AUTO_CLOSE_DELAY = 3000;
const MOBILE_AUTO_CLOSE_DELAY = 1500;
const isMobile = inject('isMobile') as Ref<boolean>;

const { showPopup, likedProduct, hidePopup } = useLikedProductPopup();
const sessionStore = useSessionStore();

const productImageToShow = computed(() => {
  if (!likedProduct.value) return '';
  return likedProduct.value.images?.[0]?.derivatives?.jpgMd?.url;
});

const linkUrl = computed(() => {
  if (sessionStore.user?.kind === 'shop') {
    return '/shops/account?tab=likedProducts';
  }
  return '/products';
});

function closePopup() {
  hidePopup();
}

watch(
  () => showPopup.value,
  (isVisible) => {
    if (isVisible) {
      const delay = isMobile?.value ? MOBILE_AUTO_CLOSE_DELAY : AUTO_CLOSE_DELAY;
      setTimeout(() => {
        hidePopup();
      }, delay);
    }
  },
);
</script>
